import { render, staticRenderFns } from "./DailyBusinessTrendReport.vue?vue&type=template&id=2aff31d4&"
import script from "./DailyBusinessTrendReport.vue?vue&type=script&lang=ts&"
export * from "./DailyBusinessTrendReport.vue?vue&type=script&lang=ts&"
import style0 from "./DailyBusinessTrendReport.vue?vue&type=style&index=0&id=2aff31d4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports